interface EmptyStateProps {
  icon?: string;
  title: string;
  desc: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  desc,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-900">{title}</h3>
      <p className="mt-1.5 max-w-md text-sm leading-relaxed text-foreground-600">
        {desc}
      </p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}